/* eslint-disable no-nested-ternary */
import { BlueBirdTheme, Checkbox, Typography } from "@kitbird/core";
import { Control, Controller, UseFormSetValue } from "react-hook-form";
import {
  CardBody, CardContainer, CardHeader, CardTitle,
} from "../BusinessCard";
import { IBusinessTrxFormValues } from "../../types";
import BaseLoading from "../../../../../components/Loading/BaseLoading";
import EmptyState from "../EmptyState";
import { useFormBusinessTrx } from "../../FormBusinessTrxProvider";

interface StepAreaSelectionProps {
  control: Control<IBusinessTrxFormValues>;
  setValue: UseFormSetValue<IBusinessTrxFormValues>;
}

const StepAreaSelection = ({ control, setValue }: StepAreaSelectionProps) => {
  const {
    selectedAreaIds,
    isFetchingArea,
    resArea,
    allAreaIds,
    isEditMode,
  } = useFormBusinessTrx();

  return (
    <CardContainer>
      <CardHeader>
        <CardTitle>
          <Typography level={4} fontWeight="bold" color={BlueBirdTheme.colors.gray.subtitle}>
            Pilih area
          </Typography>
        </CardTitle>
      </CardHeader>
      <CardBody gridTemplateColumns="repeat(auto-fit, minmax(284px, 1fr))" style={{ marginBottom: "12px" }}>
        {isFetchingArea ? (
          <BaseLoading />
        ) : resArea.length ? (
          <>
            {!isEditMode && (
              <Checkbox
                label="Semua area"
                checked={resArea.length > 0 && resArea.every(
                  (a) => selectedAreaIds.includes(a.area_id),
                )}
                onChange={(e) => {
                  const currentSelected = new Set(selectedAreaIds);
                  allAreaIds.forEach((id) => (
                    e.target.checked ? currentSelected.add(id) : currentSelected.delete(id)
                  ));
                  setValue("selectedAreaIds", Array.from(currentSelected));
                }}
              />
            )}
            {resArea.map((area) => (
              <Controller
                key={area.area_id}
                name="selectedAreaIds"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <Checkbox
                    key={area.area_id}
                    label={area.area_name}
                    checked={value && value.includes(area.area_id)}
                    onChange={(e) => {
                      if (isEditMode) {
                        onChange(e.target.checked ? [area.area_id] : []);
                      } else {
                        onChange(e.target.checked
                          ? [...(value || []), area.area_id]
                          : value?.filter((id: string) => id !== area.area_id));
                      }
                    }}
                  />
                )}
              />
            ))}
          </>
        ) : (
          <EmptyState />
        )}
      </CardBody>
    </CardContainer>
  );
};

export default StepAreaSelection;
